import React from 'react';
import { Link } from 'react-router-dom';

const SkeletonCreateEdit = () => {
  return (
    <div className='newscreate pr-10 max-lg:pr-6'>
      <Link to={'/popup_banner'} className="back flex items-center mb-6 gap-2">
        <span className='text-[1.4rem] font-MluvkaBold'>Popup Banner</span>
      </Link>
      <div className='bg-[#EFF4FD] p-6 rounded-3xl mb-8 min-h-[30rem] animate-pulse'>
        <div className='h-[3rem] bg-white/80 rounded-xl mb-4'></div>
        <div className='h-[3rem] bg-white/80 rounded-xl mb-4'></div>
        <div className='grid grid-cols-2 gap-4 max-lg:grid-cols-1 mb-4'>
          <div className='h-[3rem] bg-white/80 rounded-xl'></div>
          <div className='h-[3rem] bg-white/80 rounded-xl'></div>
        </div>
        <div className='h-[10rem] bg-white/80 rounded-3xl mb-4'></div>
        <div className='h-[2rem] w-[12rem] bg-white/80 rounded-full'></div>
      </div>
    </div>
  );
};

export default SkeletonCreateEdit;
